module.exports = jQuery;


/*****************
 ** WEBPACK FOOTER
 ** external "jQuery"
 ** module id = 3
 ** module chunks = 0 1 12 13
 **/